var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96223 19L6.84106 18.7281C5.35655 15.3973 3.41235 12.291 1.06525 9.5V9.5H12.9348V9.5C10.5624 12.291 8.59213 15.4002 7.08122 18.7372L6.96223 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.4857C10.866 12.4857 14 9.69069 14 6.24286C14 2.79502 10.866 0 7 0C3.13401 0 0 2.79502 0 6.24286C0 9.69069 3.13401 12.4857 7 12.4857ZM7 8.27857C8.26065 8.27857 9.28261 7.36715 9.28261 6.24286C9.28261 5.11856 8.26065 4.20714 7 4.20714C5.73935 4.20714 4.71739 5.11856 4.71739 6.24286C4.71739 7.36715 5.73935 8.27857 7 8.27857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.5de0d12713f190dccf53df8c52e5f96a.svg";
export { ForwardRef as ReactComponent };